import {
  Box,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useMemo, useState } from "react";
import ProductCard from "../../components/product-card";
import { createApiCall } from "../../api/api-service";
import { useParams, useSearchParams } from "react-router-dom";
import { Search, Clear } from "@mui/icons-material";
import BrandHeaderCard from "./brand-components/brandheader";
import ProductCarousel from "../../components/Carousel/product-carousel";
import CommonLabel from "../../components/label";
import ChipsBox from "../../components/chips-box";
import CommonFilterBox from "../../components/filter-box";
import ProductGrid from "../../components/product-grid";
import CommonTextBox from "../../components/TextBoxes/common-text-box";
import CommonPagination from "../../components/pagination/common-pagination";
import { useQuery } from "@tanstack/react-query";
import LoadingGIF from "../../components/loading-gif";

const BrandProductPage = () => {
  let { brandname } = useParams();
  let [searchParams, setSearchParams] = useSearchParams();
  // const [brandProduct, setBrandProduct] = useState();
  // const [productsLength, setProductsLength] = useState(0);
  // const [filterdProduct, setFilteredProduct] = useState([]);
  // const [brandDetail, setBrandDetail] = useState();
  // const [brandExploreProduct, setBrandExploreProduct] = useState([]);
  // const [productCount, setProductCount] = useState({});
  const [selectedChip, setSelectedChip] = useState("All Categories");
  const [searchedProduct, setSearchedProduct] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const filterValues = useMemo(() => Object.fromEntries([...searchParams]), [searchParams]);
  const searchParamsString = searchParams.toString();
  // const [isLoadingPage, setIsLoadingPage] = useState(false);
  const filterSections = [
    {
      key: "price",
      header: "Price",
      values: [" ₹ 10 - 399", "₹ 400 - 699", "₹ 700 - 999", "Above ₹999"],
      type: "radio",
    },
    {
      key: "category",
      header: "Category",
      values: ["Beauty",
            "Bath & Spa",
            "Skincare",
            "Hair Styling",
            "Sexual Wellness",
            "Miscelleanous"],
      type: "radio",
    },
    {
      key: "availability",
      header: "Availability",
      values: ["In Stock", "Out of Stock"],
      type: "radio",
    },
  ];
  const fetchBrandWiseProduct = async () => {
    const data = await createApiCall(
      "POST",
      "inventory/fetch_brand_recently_added_products",
      {
        brand_name: brandname,
      },
    );
    // Normalize response to array
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;
    return Object.values(data || {});
  };

  const fetchBrandExploreProducts = async (page = 1) => {
    try {
      const payload = {
        brand_name: brandname,
        page,
        page_size: 20,
        ...filterValues,
      };
      const data = await createApiCall(
        "POST",
        "inventory/fetch_brand_explore_products",
        payload,
        true,
      );
      return data || {};
    } catch (error) {
      // bubble up to react-query
      throw error;
    }
  };
  const fetchBrandInformation = async () => {
    const data = await createApiCall(
      "POST",
      "inventory/fetch_brand_information",
      {
        brand_name: brandname,
      },
    );
    return data || {};
  };
  // derive filtered products from search and fetched products
  const fetchBrandFilter = async () => {
    const data = await createApiCall("POST", "inventory/fetch_brand_filters", {
      brand_name: brandname,
    });
    return data || [];
  };
  const clearSearch = () => {
    setSearchedProduct("");
    // setFilteredProduct(brandProduct);
  };

  const {
    data: brandDetail,
    isLoading: isBrandLoading,
    isError: isBrandError,
  } = useQuery({
    queryKey: ["brand", "details", brandname],
    queryFn: fetchBrandInformation,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  const {
    data: brandProduct = [],
    isLoading: isProductsLoading,
    isError: isProductsError,
  } = useQuery({
    queryKey: ["brand", "products", brandname],
    queryFn: fetchBrandWiseProduct,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  const {
    data: exploreData = {},
    isLoading: isExploreDataLoading,
    isError: isExploreDataError,
  } = useQuery({
    queryKey: ["brand", "explore", brandname, currentPage, searchParamsString],
    queryFn: () => fetchBrandExploreProducts(currentPage),
    staleTime: 5 * 60 * 1000,
    retry: 1,
    keepPreviousData: true,
  });

  // const {
  //   data: filterSections,
  //   isLoading: isFilterLoading,
  //   isError: isFilterError,
  // } = useQuery({
  //   queryKey: ["brand", "explore", brandname],
  //   queryFn: fetchBrandFilter,
  //   staleTime: "infinte",
  //   retry: 1,
  // });
  const brandExploreProduct = exploreData?.data || [];
  const productCount = exploreData?.pagination || {};

  const filteredProducts = useMemo(() => {
    if (!searchedProduct || searchedProduct.length < 3)
      return brandProduct || [];
    return (brandProduct || []).filter((item) =>
      item?.variant_name?.toLowerCase().includes(searchedProduct.toLowerCase()),
    );
  }, [searchedProduct, brandProduct]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleFilterChange = (nextFilters) => {
    setCurrentPage(1);
    const currentParams = Object.fromEntries([...searchParams]);
    const nextParams = Object.entries({
      ...currentParams,
      ...nextFilters,
    }).reduce((acc, [key, value]) => {
      if (value === undefined || value === null || value === "") {
        return acc;
      }
      acc[key] = Array.isArray(value) ? value.join(",") : value;
      return acc;
    }, {});
    setSearchParams(nextParams);
  };

  const showExploreLoading = isExploreDataLoading;

  if (isBrandLoading) return <LoadingGIF />;
  return (
    <>
      {/* <Container sx={{ padding: '10px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" >{brandname}</Typography>
                    <Typography variant="body1" >{productsLength} Products</Typography>
                </Box>
                 <Box sx={{display:'flex',alignItems:'center', justifyContent:'center',my:'10px'}}>
                    <TextField variant="standard" label="Search Product" name="search_product" value={searchedProduct} onChange={(e)=>{setSearchedProduct(e.target.value)}} InputProps={{
                        startAdornment:(
                            <InputAdornment position="start"> <IconButton onClick={handleChange}><Search/> </IconButton></InputAdornment>
                        ),
                        endAdornment: searchedProduct && (
                            <InputAdornment position="end" ><IconButton onClick={clearSearch}>
                                 <Clear/></IconButton></InputAdornment>
                        )
                    }}/>
                </Box>
                <Grid container spacing={2} alignItems={'center'} justifyContent={'center'}>
                    {
                        filterdProduct.map((item) => {
                            return (<Grid item size={{xs:'6' ,sm:'4'}}><ProductCard cardUrl={item?.variant_url} cardText={item?.variant_name} cardImage={item?.variant_image} /></Grid>)
                        })
                    }
                </Grid>

            </Container> */}
      <Container>
        <BrandHeaderCard brandDetail={brandDetail} />

        <ProductCarousel
          label={"New Launches"}
          products={brandProduct}
          onProductClick={(product) => console.log("Clicked:", product)}
        />

        <Box
          sx={{
            width: "100%",
            // px: { xs: 1.5, sm: 2, md: 3 },
            py: { xs: 2, sm: 2.5, md: 3 },
            bgcolor: "#fff",
          }}
        >
          <CommonLabel
            sx={{
              fontSize: { xs: "18px", sm: "22px" },
              fontWeight: 700,
              color: "#111",
              textTransform: "uppercase",
              lineHeight: 1.2,
            }}
          >
            Explore All Products
          </CommonLabel>
{/* 
          <ChipsBox
            itemList={["All Categories", "Foundation", "Brush", "Primer"]}
            highlightChip={selectedChip}
            handleCategoryChange={(name) => {
              setSelectedChip(name);
            }}
          /> */}

          <Box sx={{ display: "flex", marginTop: "10px", gap: 7 }}>
            <Box
              sx={{
                display: { xs: "none", sm: "none", md: "block", lg: "block" },
                width: "20%",
              }}
            >
              <CommonFilterBox
                title="Filters"
                sections={filterSections}
                onFilterChange={handleFilterChange}
              />
            </Box>
            <Box
              sx={{
                display: { md: "block", lg: "block" },
                width: {xs:'100%','sm':'100%',md:"80%"},
              }}
            >
              <CommonPagination
                page={productCount?.page || 1}
                totalPages={productCount?.total_pages || 1}
                pageSize={productCount?.page_size || 20}
                totalCount={productCount?.total_count || 0}
                onPageChange={handlePageChange}
                showResultCount={true}
              />
              <Box sx={{ mb: "10px", position: "relative" }}>
                {showExploreLoading && (
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "rgba(255,255,255,0.7)",
                      zIndex: 2,
                    }}
                  >
                    <CircularProgress size={36} sx={{ color: "#ff4f93" }} />
                  </Box>
                )}
                <ProductGrid productList={brandExploreProduct} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default BrandProductPage;
